import { createClient } from '@supabase/supabase-js'

const supabaseUrl = (process.env.REACT_APP_SUPABASE_URL || '').trim()
const supabaseKey = (process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || '').trim()

export const supabase = createClient(supabaseUrl, supabaseKey)
